import { trackEvent } from 'analytics/trackFunctions'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import ChargeMoney from 'assets/images/chargeMoney.svg'
import TransferMoney from 'assets/images/transferMoney.svg'
import WORDING from 'constants/wording'

const { CARGAR_DINERO, TRANSFERIR_DINERO } = WORDING

const ButtonContainer = () => {
  const navigate = useNavigate()
  return (
    <div className='flex py-0 bg-white border border-solid border-color-gray-500 w-full divide-color-gray-500 divide-solid shadow-b box-border rounded-lg my-6 divide-x'>
      <NavButtonUnified
        image={ChargeMoney}
        text={CARGAR_DINERO}
        onClick={() => {
          trackEvent({
            eventName: 'bille_boton_cargar_dinero_movimientos'
          })
          navigate('/cargar-dinero')
        }}
      />
      <NavButtonUnified
        image={TransferMoney}
        text={TRANSFERIR_DINERO}
        onClick={() => {
          trackEvent({ eventName: 'bille_transferir_dinero_movimientos' })
          navigate('/transferencias')
        }}
      />
    </div>
  )
}

export default ButtonContainer

// Este tipo de botón solo se utiliza en la página de movimientos
// debería revisarse y unificar su diseño

const NavButtonUnified = ({
  image,
  text,
  onClick
}: {
  image: string
  text: string
  onClick: () => void
}) => (
  <button
    type='button'
    onClick={onClick}
    className='grid grid-rows-[2rem_1fr] gap-1 py-4 text-black items-center justify-items-center justify-center w-full h-24'
  >
    <div className='w-16 justify-center row-start-1 row-end-2 flex'>
      <img src={image} alt='' />
    </div>
    <p className='text-center w-24 row-start-2 row-end-3 font-bold text-2xs leading-[120%]'>
      {text}
    </p>
  </button>
)
